import parsePhoneNumber from 'libphonenumber-js';
import { ValidationError } from 'yup';

import {
	MAX_LAT_VALUE,
	MAX_LNG_VALUE,
	MAX_UTM_VALUE,
	MIN_LAT_VALUE,
	MIN_LNG_VALUE,
	MIN_UTM_VALUE,
} from '@constants/map';
import { regExpCoord, regExpTelecomId } from '@constants/regExp';
import { MAX_10_LENGTH, MAX_50_LENGTH } from '@constants/validationMessages';

const isValidIncludePoint = (value: string, maxLength: number): boolean =>
	value.includes('.') ? value.length - 1 <= maxLength : value.length <= maxLength;

export const validatePhoneNumber = (value: string) => {
	if (!value) return true;

	const parsedPhone = parsePhoneNumber(`+${value}`);

	return !!parsedPhone?.isValid();
};

export const validateDecimalNumber = (value: any): boolean => {
	if (!value) return true;

	const regexp = /^\d+(.\d+)?$/;

	return regexp.test(value);
};

export const validateCoordsValue = (value: any): boolean => {
	if (!value) return true;

	const regexp = /^(-)?\d+(.\d+)?$/;

	return regexp.test(value);
};

export const validateLatitude = (latitude: any): boolean => {
	if (!latitude) return true;

	if (!regExpCoord.test(latitude)) return false;

	if (!isNaN(latitude)) {
		return latitude >= MIN_LAT_VALUE && latitude <= MAX_LAT_VALUE;
	}

	const parsedLatitude = parseFloat(latitude);

	return parsedLatitude >= MIN_LAT_VALUE && parsedLatitude <= MAX_LAT_VALUE;
};

export const validateLongitude = (longitude: any): boolean => {
	if (!longitude) return true;

	if (!regExpCoord.test(longitude)) return false;

	if (!isNaN(longitude)) {
		return longitude >= MIN_LNG_VALUE && longitude <= MAX_LNG_VALUE;
	}

	const parsedLongitude = parseFloat(longitude);

	return parsedLongitude >= MIN_LNG_VALUE && parsedLongitude <= MAX_LNG_VALUE;
};

export const validateUtmCoordinateValue = (value: any) => {
	if (/^\d+$/.test(value)) {
		const parsedValue = parseFloat(value);

		if (!isNaN(parsedValue)) {
			return parsedValue >= MIN_UTM_VALUE && parsedValue <= MAX_UTM_VALUE;
		}
	}

	return false;
};

export const validateLengthPrice = (value: any): boolean => {
	if (!value) return true;

	return isValidIncludePoint(value, MAX_10_LENGTH);
};

export const validateLengthCoords = (value: any): boolean => {
	if (!value) return true;

	return isValidIncludePoint(value, MAX_50_LENGTH);
};

export const validateFloatingPointLength = (
	value: string,
	floatingPointLength: number,
): boolean | ValidationError | Promise<boolean | ValidationError> => {
	if (value && value.split('.')[1]?.length > floatingPointLength) return false;

	return true;
};

export const validateTelecomId = (value: any): boolean | ValidationError | Promise<boolean | ValidationError> => {
	return regExpTelecomId.test(value);
};

export const passwordsMatchValidator = (
	value: string,
	context: {
		parent: {
			newPassword: string;
		};
	},
): boolean => value === context.parent.newPassword;

export const validateIpV4Address = (ipAddress?: string): boolean => {
	if (!ipAddress) return false;

	// eslint-disable-next-line max-len
	const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

	return ipv4Pattern.test(ipAddress);
};
